//SDK //API
const gamesnacks = window.GameSnacks;

export class SDKManager {

    public static totalAdsCount: number = 1;
    public static adsWatchedCount: number = 1; // Reset to 0 to activate ads.

    public static canCheckRoadTexture: boolean = false;

    public static isFirstTime: boolean = false;
    public static quitGame: boolean = false;

    public static getPlayerFirstTimeMetaData() {
        let data:any = "";
        if(SDKManager.isLocalData){
            data = localStorage.getItem('hammerplay_rampageroad_isPlayerFirstTime');
        }
        else{
            data = SDKManager.getItem('rampageroad_isPlayerFirstTime');
        }
        data = JSON.parse(data);
        if (data == null) {
            SDKManager.setPlayerFirstTimeMetaData(true);
        } else {
            SDKManager.isFirstTime = Boolean(data.isPlayerFirstTime);
        }
    }

    public static setPlayerFirstTimeMetaData(value: boolean) {
        if(SDKManager.isLocalData){
            localStorage.setItem('hammerplay_rampageroad_isPlayerFirstTime', JSON.stringify({
                isPlayerFirstTime: value,
            }));
        }else{
            SDKManager.setItem('rampageroad_isPlayerFirstTime', JSON.stringify({
                isPlayerFirstTime: value,
            }));
        }
    }

    public static highscore: number = 0;

    public static getPlayerHighscoreMetaData() {
        let data:any = "";
        if(SDKManager.isLocalData){
            data = localStorage.getItem('hammerplay_rampageroad_highscore');
        }
        else{
            data = SDKManager.getItem('rampageroad_highscore');
        }
        data = JSON.parse(data);
        if (data == null) {
            SDKManager.setPlayerHighscoreMetaData(SDKManager.highscore);
        } else {
            SDKManager.highscore = Number(data.highscore);
        }
    }

    public static setPlayerHighscoreMetaData(value: number) {
        if(SDKManager.isLocalData){
            localStorage.setItem('hammerplay_rampageroad_highscore', JSON.stringify({
                highscore: value,
            }));
        }
        else{
            SDKManager.setItem('rampageroad_highscore', JSON.stringify({
                highscore: value,
            }));
        }
    }

    public static coins: number = 0;

    public static getPlayerCoinsMetaData() {
        let data:any = "";
        if(SDKManager.isLocalData){
            data = localStorage.getItem('hammerplay_rampageroad_coins');
        }
        else{
            data = SDKManager.getItem('rampageroad_coins');
        }
        data = JSON.parse(data);
        if (data == null) {
            SDKManager.setPlayerHighscoreMetaData(SDKManager.coins);
        } else {
            SDKManager.coins = Number(data.coins);
        }
    }

    public static setPlayerCoinsMetaData(value: number) {
        if(SDKManager.isLocalData){
        localStorage.setItem('hammerplay_rampageroad_coins', JSON.stringify({
            coins: value,
        }));
    }
    else{
        SDKManager.setItem('rampageroad_coins', JSON.stringify({
            coins: value,
        }));
    }
        window.gameEvents.emit("onDisableLoadingScreen");
    }

    public static carEquipped: number = 0;
    public static defaultCarEquippedStatus: any = [{ "bought": true, "isEquipped": true, "cost": 0 },
    { "bought": false, "isEquipped": false, "cost": 2500 },
    { "bought": false, "isEquipped": false, "cost": 2500 },
    { "bought": false, "isEquipped": false, "cost": 3500 },
    { "bought": false, "isEquipped": false, "cost": 3500 },
    { "bought": false, "isEquipped": false, "cost": 4500 },
    { "bought": false, "isEquipped": false, "cost": 4500 }];
    public static carEquippedStatus: any = SDKManager.defaultCarEquippedStatus;

    public static getPlayerCarEquippedMetaData() {
        let data:any = "";
        if(SDKManager.isLocalData){
            data = localStorage.getItem('hammerplay_rampageroad_carEquipped');
        }
        else{
            data = SDKManager.getItem('rampageroad_carEquipped');
        }
        data = JSON.parse(data);
        if (data == null) {
            SDKManager.setPlayerCarEquippedMetaData(SDKManager.carEquipped);
        } else {
            SDKManager.carEquipped = data.carEquipped;
        }
    }

    public static setPlayerCarEquippedMetaData(value: number) {
        if(SDKManager.isLocalData){
            localStorage.setItem('hammerplay_rampageroad_carEquipped', JSON.stringify({
                carEquipped: value,
            }));
        }
        else{
            SDKManager.setItem('rampageroad_carEquipped', JSON.stringify({
                carEquipped: value,
            }));
        }
    }

    public static getPlayerCarEquippedStatusMetaData() {
        let data:any = "";
        if(SDKManager.isLocalData){
            data = localStorage.getItem('hammerplay_rampageroad_carEquippedStatus');

        }
        else{
            data = SDKManager.getItem('rampageroad_carEquippedStatus');

        }
        data = JSON.parse(data);
        if (data == null) {
            SDKManager.setPlayerCarEquippedStatusMetaData(SDKManager.defaultCarEquippedStatus);
        } else {
            let updateData = false;
            SDKManager.carEquippedStatus = data.carEquippedStatus;
            if (SDKManager.carEquippedStatus.length < SDKManager.defaultCarEquippedStatus.length) {
                updateData = true;
                for (let i = SDKManager.carEquippedStatus.length; i < SDKManager.defaultCarEquippedStatus.length; i++) {
                    SDKManager.carEquippedStatus[i] = SDKManager.defaultCarEquippedStatus[i];
                }
            }
            for (let index = 0; index < SDKManager.carEquippedStatus.length; index++) {
                if (SDKManager.carEquippedStatus[index].cost != SDKManager.defaultCarEquippedStatus[index].cost) {
                    updateData = true;
                    SDKManager.carEquippedStatus[index].cost = SDKManager.defaultCarEquippedStatus[index].cost;
                }
            }
            if (updateData) {
                SDKManager.setPlayerCarEquippedStatusMetaData(SDKManager.carEquippedStatus);
            }
        }
    }

    public static setPlayerCarEquippedStatusMetaData(value: any) {
        if(SDKManager.isLocalData){
            localStorage.setItem('hammerplay_rampageroad_carEquippedStatus', JSON.stringify({
                carEquippedStatus: value,
            }));

        }
        else{
            SDKManager.setItem('rampageroad_carEquippedStatus', JSON.stringify({
                carEquippedStatus: value,
            }));
        }
    }

    public static mapEquipped = 0;
    public static defaultMapEquippedStatus = [{ "bought": true, "isEquipped": true, "cost": 0 },
    { "bought": false, "isEquipped": false, "cost": 2500 },
    { "bought": false, "isEquipped": false, "cost": 2500 }];
    public static mapEquippedStatus = SDKManager.defaultMapEquippedStatus;

    public static getPlayerMapEquippedMetaData() {
        let data:any = "";
        if(SDKManager.isLocalData){
            data = localStorage.getItem('hammerplay_rampageroad_mapEquipped');

        }
        else{
            data = SDKManager.getItem('rampageroad_mapEquipped');

        }
        data = JSON.parse(data);
        if (data == null) {
            SDKManager.setPlayerMapEquippedMetaData(SDKManager.mapEquipped);
        }
        else {
            SDKManager.mapEquipped = data.mapEquipped;
        }
    }

    public static setPlayerMapEquippedMetaData(value: number) {
        if(SDKManager.isLocalData){

            localStorage.setItem('hammerplay_rampageroad_mapEquipped', JSON.stringify({
                mapEquipped: value,
            }));
        }
        else{
            SDKManager.setItem('rampageroad_mapEquipped', JSON.stringify({
                mapEquipped: value,
            }));

        }
    }

    static getPlayerMapEquippedStatusMetaData() {
        let data:any = "";
        if(SDKManager.isLocalData){
            data = localStorage.getItem('hammerplay_rampageroad_mapEquippedStatus');

        }
        else{
            data = SDKManager.getItem('rampageroad_mapEquippedStatus');

        }
        data = JSON.parse(data);
        if (data == null) {
            SDKManager.setPlayerMapEquippedStatusMetaData(SDKManager.defaultMapEquippedStatus);
        }
        else {
            let updateData = false;
            SDKManager.mapEquippedStatus = data.mapEquippedStatus;
            if (SDKManager.mapEquippedStatus.length < SDKManager.defaultMapEquippedStatus.length) {
                updateData = true;
                for (let i = SDKManager.mapEquippedStatus.length; i < SDKManager.defaultMapEquippedStatus.length; i++) {
                    SDKManager.mapEquippedStatus[i] = SDKManager.defaultMapEquippedStatus[i];
                }
            }
            for (let index = 0; index < SDKManager.mapEquippedStatus.length; index++) {
                if (SDKManager.mapEquippedStatus[index].cost != SDKManager.defaultMapEquippedStatus[index].cost) {
                    updateData = true;
                    SDKManager.mapEquippedStatus[index].cost = SDKManager.defaultMapEquippedStatus[index].cost;
                }
            }
            if (updateData) {
                SDKManager.setPlayerMapEquippedStatusMetaData(SDKManager.mapEquippedStatus);
            }
        }
    }

    public static setPlayerMapEquippedStatusMetaData(value: any) {
        if(SDKManager.isLocalData)[

            localStorage.setItem('hammerplay_rampageroad_mapEquippedStatus', JSON.stringify({
                mapEquippedStatus: value,
            }));
        ]
        else{

            SDKManager.setItem('rampageroad_mapEquippedStatus', JSON.stringify({
                mapEquippedStatus: value,
            }));
        }
    }



    public static isLocalData:boolean = false;
    public static isAudioOn:boolean = true;
    public static isAdPlaying:boolean = false;

      public static gameReady() {
        if(!SDKManager.isLocalData){
          gamesnacks.game.ready();
        }
      }

      public static gameOver() {
        if(!SDKManager.isLocalData){
          gamesnacks.game.gameOver();
        }
        else{
            console.log("Game Over")
        }

      }

      public static firstFrameReady() {
        if(!SDKManager.isLocalData){
          gamesnacks.game.firstFrameReady();

        }

      }

      public static levelComplete(levelNum: number){
        if(!SDKManager.isLocalData){
          gamesnacks.game.levelComplete(levelNum);

        }

      }

      public static onGamePause(callback: Function ) {
        if(!SDKManager.isLocalData){
          gamesnacks.game.onPause(callback);

        }

      }

      public static onGameResume(callback: Function){
        if(!SDKManager.isLocalData){
          gamesnacks.game.onResume(callback);

        }

      }

      public static sendScore(score: number){
        if(!SDKManager.isLocalData){
          gamesnacks.score.update(score);

        }
      }

      //ITEMS STORAGE FUNCTIONS
      public static getItem(key: string) {
        if(!SDKManager.isLocalData){
          return gamesnacks.storage.getItem(key); //Returns the current value associated with the given key
        }

        }
        public static setItem(key: string, value: string ) {
        if(!SDKManager.isLocalData){
          gamesnacks.storage.setItem(key, value) //Sets the value of the pair identified by key to value, creating a new key-value pair if none existed for key previously.

        }

        }

        public static removeItem(key: string) {
        if(!SDKManager.isLocalData){
          gamesnacks.storage.removeItem(key); //Removes the key-value pair with the given key, if a key-value pair with the given key exists

        }

        }
        public static clearStorage() {
        if(!SDKManager.isLocalData){
          gamesnacks.storage.clear(); //Removes all key-value pairs, if there are any.

        }

        }

        public static rewardAdCallback(type: string, name: string, beforeAd: Function, afterAd: Function, beforeReward: Function, adDismissed: Function, adViewed: Function, adBreakDone: Function) {
        if(!SDKManager.isLocalData){
          gamesnacks.ad.break({ type: type, name: name, beforeAd, afterAd, beforeReward, adDismissed, adViewed, adBreakDone });
        }
      }
      public static interstitialAdCallback(type: string, name: string, beforeAd: Function, afterAd: Function,  adBreakDone: Function) {
        if(!SDKManager.isLocalData){
          gamesnacks.ad.break({ type: type, name: name, beforeAd, afterAd, adBreakDone });

        }
    }
  }
  /**
   * for audio subscription
      gamesnacks.audio.subscribe((isAudioEnabled: boolean) => {
        this.musicVolume = isAudioEnabled ? 0.8 : 0;
        this.soundVolume = isAudioEnabled ? 1 : 0;
      });
   * to check if audio is enabled
      gamesnacks.audio.isEnabled()
   */

export var base64ImageURL: string = "";

export const ImageToDataURL = (imageURL) => {
    base64ImageURL = imageURL;
}